import { LOGIN_SUCCESSFUL, USER_LOGOUT } from './actionTypes';

export const userLoginSuccess = token => ({
  type: LOGIN_SUCCESSFUL,
  payload: token,
});

export const userLogout = () => ({
  type: USER_LOGOUT,
});
